import { Box, type BoxProps, Center, List, Text } from "@chakra-ui/react";
import { Spinner } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import type React from "react";
import { type FunctionComponent, useCallback } from "react";
import { useToggle } from "react-use";
import type { NotificationModel } from "../../models";
import NotificationItem from "./NotificationItem";

interface NotificationsListProps {
  items: NotificationModel[];
  loading?: boolean;
  height?: BoxProps["height"];
}

const NotificationList: FunctionComponent<
  React.PropsWithChildren<NotificationsListProps>
> = ({ items, loading, height }) => {
  const [executing, toggleExecuting] = useToggle(false);

  const onAction = useCallback(async (item: NotificationModel) => {
    if (executing) return;
    toggleExecuting(true);
    await item.exeAction();
    toggleExecuting(false);
  }, []);

  return (
    <Box overflowY="auto" h={height ? height : "60.5rem"}>
      {executing && <Spinner absolute />}
      <List>
        {items.map((item, index) => (
          <NotificationItem
            isFirst={index === 0}
            key={item.id}
            item={item}
            onAction={onAction}
          />
        ))}
      </List>
      {!loading && !items.length && (
        <Center h="full">
          <Text align="center" p="8">
            <Trans>You don't have any notifications</Trans>
          </Text>
        </Center>
      )}
    </Box>
  );
};

export default observer(NotificationList);
